import { Expose } from 'class-transformer';
import { DropdownModel } from 'src/app/core/data/model';

export class Verse extends DropdownModel {
  @Expose() id: number;
  override get dropDownDisplayName(): string {
    return `${this.id}`;
  }
  override get dropDownValue(): Object {
    return this;
  }
}
